import MergeClientCard from "./components/Layout";
import MergeButton from "./components/MergeButton";
import MergeHeader from "./components/MergeHeader";

MergeClientCard.Header = MergeHeader;
MergeClientCard.Button = MergeButton;

export { MergeClientCard };

export default MergeClientCard;
